import { render, staticRenderFns } from "./my-index.vue?vue&type=template&id=a5b20a88&scoped=true&"
import script from "./my-index.vue?vue&type=script&lang=js&"
export * from "./my-index.vue?vue&type=script&lang=js&"
import style0 from "./my-index.vue?vue&type=style&index=0&id=a5b20a88&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5b20a88",
  null
  
)

export default component.exports